/* eslint-disable react/jsx-pascal-case */
import * as S from '../styles'
import { cpfMask, cellMask, fixPhoneMask, dateFromString } from '../masks'

const Step1 = ({
  userData,
  alterarSenha,
  alterarEmail,
  editarDados,
  onChange
}) => {
  return (
    <div>
      <S.WrapperExibition>
        <S.col_group>
          <S.col12>
            <S.form_group>
              <S.label>E-maila</S.label>
              {userData.email}
            </S.form_group>
          </S.col12>

          <S.box>
            <S.col8>
              <S.form_group>
                <S.label>Nome</S.label>
                {userData.nome}
              </S.form_group>
            </S.col8>
            <S.col4>
              <S.form_group>
                <S.label>Como deseja ser chamado(a)</S.label>
                {userData.apelido}
              </S.form_group>
            </S.col4>
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>CPF</S.label>
                {cpfMask(userData.cpf)}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Sexo</S.label>
                {userData.sexo === 'M' || userData.sexo === 'm'
                  ? 'Masculino'
                  : 'Feminino'}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Data de Nascimento</S.label>
                {dateFromString(userData.dataNascimento)}
              </S.form_group>
            </S.col4>
          </S.box>
          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>Telefone Celular</S.label>
                {cellMask(
                  userData.telefoneCelularDDD + userData.telefoneCelularNumero
                )}
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Telefone Residencial</S.label>
                {fixPhoneMask(
                  userData.telefoneResidencialDDD +
                    userData.telefoneResidencialNumero
                )}
              </S.form_group>
            </S.col4>
            <S.col3 className="col-ramal">
              <S.form_group>
                <S.label>Telefone Comercial</S.label>
                {fixPhoneMask(
                  userData.telefoneComercialDDD +
                    userData.telefoneComercialNumero
                )}
              </S.form_group>
            </S.col3>
            {/* {userData.telefoneComercialRamal !== null && ( */}
            <S.col1 className="col-ramal">
              <S.form_group>
                <S.label>Ramal</S.label>
                {userData.telefoneComercialRamal}
              </S.form_group>
            </S.col1>
            {/* )} */}
          </S.box>
          <S.perfilBoxFooter>
            <S.button onClick={() => alterarSenha()}>Alterar Senha</S.button>
            <S.button onClick={() => alterarEmail()}>Alterar E-mail</S.button>
            <S.button onClick={() => editarDados()}>Editar Dados</S.button>
          </S.perfilBoxFooter>
        </S.col_group>
      </S.WrapperExibition>
    </div>
  )
}

export default Step1
